// extracted by mini-css-extract-plugin
export default {"inviteMessage":"AcceptDeclineInvite_inviteMessage__6t4uY","acceptInvite":"AcceptDeclineInvite_acceptInvite__eOyi7","declineInvite":"AcceptDeclineInvite_declineInvite__eDzBx"};